import { useState } from "react";
import { ProfileSettings } from "@/components/settings/ProfileSettings";
import { OrgSettings } from "@/components/settings/OrgSettings";
import { FinancialsSettings } from "@/components/settings/FinancialsSettings";
import { MarketDataSettings } from "@/components/settings/MarketDataSettings";

type SettingsTab = "profile" | "organization" | "financials" | "market-data";

export default function Settings() {
  const [activeTab, setActiveTab] = useState<SettingsTab>("profile");

  const tabs: { id: SettingsTab; label: string }[] = [
    { id: "profile", label: "Profile" },
    { id: "organization", label: "Organization" },
    { id: "financials", label: "Financials" },
    { id: "market-data", label: "Market Data" },
  ];

  return (
    <div className="mx-auto max-w-4xl px-4 py-8 sm:px-6 lg:px-8">
      <h1 className="mb-6 text-2xl font-bold text-slate-900">Settings</h1>

      {/* Tab navigation */}
      <div className="mb-8 inline-flex rounded-xl bg-slate-800/5 p-1">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`rounded-lg px-4 py-2 text-sm font-medium transition ${
              activeTab === tab.id
                ? "bg-white text-slate-900 shadow-sm"
                : "text-slate-500 hover:text-slate-700"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab content */}
      {activeTab === "profile" && <ProfileSettings />}
      {activeTab === "organization" && <OrgSettings />}
      {activeTab === "financials" && <FinancialsSettings />}
      {activeTab === "market-data" && <MarketDataSettings />}
    </div>
  );
}
